import { MoneyScaled } from '@quickbit/qb-design-system';
import { fetchAPI } from 'api';
import { Wallet } from 'types';
import { PaymentMethod } from 'types/piqPaymentMethod';

export interface GetWalletsResponse {
  accounts: Wallet[];
}

interface Merchant {
  displayName: string;
  uuid: string;
}

export interface ErrorData {
  errorCode: string;
  details: Record<string, unknown>;
  createdAt: Date;
}
export interface ReceiveOrderDetails {
  amount: MoneyScaled;
  cryptoAmount: MoneyScaled;
  address: string;
  merchant: Merchant;
  status: string;
  errors?: ErrorData[];
  redirectUrl?: string;
  failureRedirectUrl?: string;
  logoUrl?: string;
  logoEnabled?: boolean;
  paymentMethod?: PaymentMethod;
}

export const getWallets = async () => {
  return fetchAPI<GetWalletsResponse>(`accounts`);
};

export const getReceiveOrderDetails = async (receiveOrderPreviewId: string) => {
  return fetchAPI<ReceiveOrderDetails>(
    `receive/orders/${receiveOrderPreviewId}`
  );
};

export const cancelOrder = async (receiveOrderPreviewId: string) =>
  await fetchAPI<{ success: boolean }>(
    `receive/orders/${receiveOrderPreviewId}`,
    {
      method: 'DELETE',
    }
  );
